import { useWebChatFullStore } from '@/stores/webChatFull'
import { getUser } from '@/helpers/tokenStorage'

interface IframeControl {
  updateCoreValuesOnStore (): void;
  notifyOpen (): void;
  notifyClose (): void;
}

export default function useIframeControl (): IframeControl {
    const webChatChatFull = useWebChatFullStore()

    function updateCoreValuesOnStore (): void {

        const query = new URLSearchParams(window.location.search)
        const clientName = query.get('client_name') ?? query.get('clientName') ?? query.get('name') ?? null
        const clientEmail = query.get('client_email') ?? query.get('clientEmail') ?? query.get('email') ??  null
        const customToken = query.get('custom_token') ?? query.get('customToken') ?? null
        const customName = query.get('name') ?? null

        const cacheUser = getUser()

        if (process.env.NODE_ENV === 'production') {
            // CUSTOM FIELDS
            const payload = {
                ...webChatChatFull.item,
                apiKey: query.get('api_key') ?? query.get('apiKey') ?? '',
                currentPage : query.get('page') ?? '',
                user : cacheUser ?? query.get('user') ?? '',
            }

            if(clientName) payload.name = clientName
            if(clientEmail) payload.email = clientEmail
            if(customToken) payload.custom_token = customToken
            if(customName) payload.name = customName

            webChatChatFull.update(payload);
            // SET CACHE
            return
        }

    // SET CACHE
        const payload = {
            ...webChatChatFull.item,
            apiKey: `${process.env.VUE_APP_WEB_CHAT_API_KEY}`,
            wsToken : `${process.env.VUE_APP_WEB_WS_TOKEN}`,
            user : query.get('user') ?? '',
            currentPage : 'http://localhost:8081/web-chat-full',
            name: clientName ?? '',
            email: clientEmail ?? '',
            custom_token: customToken ?? '',
            businessId: 6,
            channel: 4693,
        }
        webChatChatFull.update(payload)
    }

    function notifyOpen (): void {
        window.parent.postMessage({
        isWidget: true,
        isOpen: true,
        step: webChatChatFull.item.currentComponent
        }, '*')
    }

    function notifyClose (): void {
        window.parent.postMessage({
        isWidget: true,
        isOpen: false
        }, '*')
    }

    return {
        updateCoreValuesOnStore,
        notifyClose,
        notifyOpen
    }
}
